import { Badge } from "primereact/badge";
import { Button } from "primereact/button";

import { C } from "../../utils";
import type { ChatSession } from "../../../client/svcLearnerAi";
import { chatSessionDisplayTitle } from "../../../client/svcLearnerAi";

export interface ChatSessionButtonProps {
  session: ChatSession;
  selected: boolean;
  disabled: boolean;
  showTenant?: boolean;
  onClick: () => void;
}

const formatSessionDate = (value?: string): string => {
  if (!value) return "Recent";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "Recent";

  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
};

export function ChatSessionButton({
  session,
  selected,
  disabled,
  showTenant = false,
  onClick,
}: ChatSessionButtonProps) {
  const title = chatSessionDisplayTitle(session);

  return (
    <Button
      unstyled
      type="button"
      aria-current={selected ? "true" : undefined}
      className={C(
        "text-left rounded border px-3 py-2 transition-colors cursor-pointer disabled:opacity-60",
        selected
          ? "border-primary bg-elevation-2"
          : "border-transparent hover:border-surface-300 hover:bg-elevation-3"
      )}
      disabled={disabled}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="font-medium text-sm leading-snug truncate">{title}</div>
        {showTenant && session.tenant && <Badge value={session.tenant} severity="secondary" />}
      </div>
      <div className="text-xs text-muted-aaa mt-1 truncate">
        {formatSessionDate(session.updatedAt)}
      </div>
    </Button>
  );
}
